export interface Category {
  id: string;
  displayName: string;
  items: Item[];
}

export interface Item {
  id: string;
  displayName: string;
  text?: string; // Can be plain text, HTML, or even Markdown
}

export const emptyItem: Item = {
  id: "EMPTY",
  displayName: "",
};
